var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75V21.7733C11 22.1875 11.3358 22.5233 11.75 22.5233C12.1642 22.5233 12.5 22.1875 12.5 21.7733V15.4479C13.7839 15.75 15.1093 15.8373 16.4224 15.706C17.2125 15.627 18.0084 15.627 18.7985 15.706L19.8398 15.8101C20.3894 15.8651 20.8663 15.4335 20.8663 14.8812V10.2971C20.8663 9.7885 20.4809 9.36262 19.9748 9.31201L18.7985 9.19439C18.0084 9.11538 17.204 9.11623 16.4139 9.19524C15.1084 9.32579 13.7769 9.23914 12.5 8.93659V8.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.25C4.41421 1.25 4.75 1.58579 4.75 2V2.21174C4.81191 2.21142 4.87515 2.21879 4.93865 2.23466C6.96432 2.74108 9.08477 2.89152 11.1624 2.68376C12.3757 2.56243 13.6112 2.56112 14.8245 2.68245L17.0995 2.90995C17.6107 2.96107 18 3.39124 18 3.90499V7.64109C17.4202 7.6245 16.839 7.64524 16.2647 7.70268C15.4153 7.78762 14.5533 7.76725 13.709 7.64255C13.3226 6.96036 12.59 6.5 11.75 6.5C10.5074 6.5 9.5 7.50736 9.5 8.75V12.7728C7.95327 12.7854 6.40889 12.6022 4.90393 12.226L4.75 12.1875V22C4.75 22.4142 4.41421 22.75 4 22.75C3.58579 22.75 3.25 22.4142 3.25 22V2C3.25 1.58579 3.58579 1.25 4 1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/flags.e7abeddc6cccac417962bdddad1918ee.svg";
export { ForwardRef as ReactComponent };